<template>
  <!-- Content -->
  <CRow>
    <CCol col="12">
      <CForm>
        <CModal
          title="Remover"
          color="danger"
          :show.sync="removeModal.show"
          :centered="true"
        >
          Ao confirmar essa ação o item não poderá ser recuperado, tem certeza que desejar continuar?
          <template #footer>
            <button
              type="button"
              class="btn btn-secondary"
              @click="toggleModal"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn btn-danger"
              @click="forceDelete"
            >
              Remover
            </button>
          </template>
        </CModal>

        <!-- Back -->
        <CRow>
          <CCol lg="12">
            <div class="d-flex align-items-center justify-content-end mb-3">
              <CButton
                color="danger ml-4"
                @click="toggleModal"
              >
                Excluir Permanentemente
              </CButton>
              <a
                class="ml-4"
                href="javascript:void(0)"
                @click="$router.go(-1)"
              ><CIcon
                name="cil-arrow-left"
                class="mr-2"
              />Voltar</a>
            </div>
          </CCol>
        </CRow>

        <CCard>
          <CCardHeader class="d-flex justify-content-between align-items-center">
            <h4 class="mb-0">
              Newsletter
            </h4>
          </CCardHeader>
        </CCard>

        <CCard>
          <CCardHeader class="d-flex justify-content-between align-items-center">
            <h5 class="mb-0 d-flex align-items-center">
              <CIcon
                name="cil-justify-center"
                class="mt-md-1 mr-2"
              />
              Informações
              <img
                v-if="languageFlag"
                :src="require(`@/assets/img/flags/${languageFlag}.svg`)"
                alt="Bandeira do idioma"
                class="flag ml-2 mt-sm-1"
              />
            </h5>
          </CCardHeader>

          <CCardBody class="pb-0">
            <CRow>
              <CCol
                lg="12"
                md="12"
                sm="12"
              >
                <CRow>
                  <CCol
                    lg="3"
                    md="3"
                    sm="3"
                  >
                    <p>
                      <b>Data de envio</b><br>
                      {{ newsletter.date }}
                    </p>
                  </CCol>
                  <CCol
                    lg="3"
                    md="3"
                    sm="3"
                  >
                    <p>
                      <b>Nome</b><br>
                      {{ newsletter.name }}
                    </p>
                  </CCol>
                  <CCol
                    lg="3"
                    md="3"
                    sm="3"
                  >
                    <p>
                      <b>E-mail</b><br>
                      {{ newsletter.email }}
                    </p>
                  </CCol>
                  <CCol
                    lg="3"
                    md="3"
                    sm="3"
                  >
                    <p>
                      <b>Tipo</b><br>
                      {{ newsletter.type }}
                    </p>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>

            <CRow>
              <CCol
                lg="12"
                md="12"
                sm="12"
              >
                <CRow>
                  <CCol
                    lg="3"
                    md="3"
                    sm="3"
                  >
                    <p>
                      <b>Idioma</b><br>
                      {{ newsletter.language }}
                    </p>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>

        <CCard>
          <CCardHeader class="d-flex justify-content-between align-items-center">
            <h5 class="mb-0">
              <CIcon
                name="cil-justify-center"
                class="mb-1 mr-2"
              />
              Dados restritos
            </h5>
          </CCardHeader>

          <CCardBody class="pb-0">
            <CRow>
              <CCol
                lg="3"
                md="3"
                sm="3"
              >
                <p>
                  <b>IP:</b><br>
                  {{ newsletter.ip }}
                </p>
              </CCol>
              <CCol
                lg="3"
                md="3"
                sm="3"
              >
                <p>
                  <b>Data aceite dos termos:</b><br>
                  {{ newsletter.accepted }}
                </p>
              </CCol>
              <CCol
                lg="3"
                md="3"
                sm="3"
              >
                <p>
                  <b>Navegador:</b><br>
                  {{ newsletter.browser }}
                </p>
              </CCol>
              <CCol
                lg="3"
                md="3"
                sm="3"
              >
                <p>
                  <b>Sistema operacional:</b><br>
                  {{ newsletter.os }}
                </p>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CForm>
    </CCol>
  </CRow>
</template>

<script>

import moment from 'moment'

// Services
import Service from '@/services/newsletter.service'

export default {
  metaInfo: {
    title: 'Newsletter',
    titleTemplate: ' %s - Manager - Intelli'
  },

  data() {
    return {
      newsletter: {
        date: '',
        name: '',
        phone: '',
        email: '',
        type: '',
        language: '',
        accepted: '',
        ip: '',
        browser: '',
        os: ''
      },
      removeModal: {
        show: false,
        title: '',
        message: '',
        color: ''
      }
    }
  },

  computed: {
    languageFlag() {
      const languageId = parseInt(this.newsletter.language_id)

      if (languageId === 1) {
        return 'pt-br'
      } else if (languageId === 2) {
        return 'en'
      } else if (languageId === 3) {
        return 'es'
      } else {
        return null
      }
    }
  },

  async created() {
    if (this.$route.params.id) {
      const response = await Service.show(
        this.$route.params.id
      )

      this.newsletter = {
        ...response,
        language: response.languageLabel,
        date: moment(response.created_at).format('DD/MM/YYYY'),
        accepted: moment(response.accepted_at).format('DD/MM/YYYY')
      }
    }
  },

  methods: {
    toggleModal() {
      this.removeModal.show = !this.removeModal.show
    },

    async forceDelete() {
      this.toggleModal()
      const response = await Service.forceDelete(this.$route.params.id, { type: 'Contato', name: this.newsletter.name })

      if (response && response.status === 200) {
        this.$notify({
          group: 'notifications',
          type: 'success',
          text: 'O contato foi excluído conforme a LGPD'
        })
        setTimeout(() => {
          this.processing = false
          this.$router.push(
            this.$route.matched[this.$route.matched.length - 2].path
          )
        }, 500)
      } else {
        this.$notify({
          group: 'notifications',
          type: 'error',
          text: 'Não é possivel excluir o contato'
        })
      }
    }
  }
}
</script>
